import React, { Component } from 'react';
import {Helmet} from 'react-helmet'
import { putToast, stopTimer, signin, authenticate, addToCart, getObjects, AuthenticatedUser} from '../api';
import { AvField, AvForm } from 'availity-reactstrap-validation';
import { Button} from 'reactstrap';
import '../index.scss'

// Import custom components
import TournamentCollection from "./pageParts/tournamentCollection"
import SVGLinkCollection from "./pageParts/svgLinkCollection"
                       
class Home extends Component {
    constructor(props) {
        super(props);
        const { user } = AuthenticatedUser();

        this.state = {
            loading: true, // set to false once loading is completed
            data: [],
            user: user
        };
    }

    addToCart = (itemId, quantity) => {        
        addToCart(itemId, quantity, () => {
            this.props.onHeaderDataChanged();
        });
    }

    loadTournamentPages = () => {
        this.setState({ loading: true});
        getObjects('tournamentPage').then(d2 => {
            if (d2 && d2.error) {
                console.log(d2.error);
            } else {
                const { user } = AuthenticatedUser();
                this.setState({ data: d2.tournamentPages, user: user, loading: false});
            }
        });
    };
    OnJudgeClick = () => {
        alert("judge")
    }

    onValidSubmit = (event, values) => {
        signin(values).then(data => {
            if (data.error) {
                console.log(data.error);
                putToast.error(data.error)
            } else {
                authenticate(data, () => {
                    this.props.onHeaderDataChanged();
                    this.loadTournamentPages();
                });
            }
        });    
    };
    
    onInvalidSubmit = (event, errors, values) => {
        //this.setState({errors, values});
    };

    forgot = () => {
        var text = document.getElementById("email").value;
        this.props.history.push(`/pages/forgot-password?&em=${text}`)
    }
    

    componentDidMount() {
        this.loadTournamentPages();
    }
//                                        columns={['imageUrl', 'title', 'status', 'publishedAt']}

    render(){
        if (this.state.loading) { return null; }
        stopTimer();     
        const {user, data} = this.state;

        const hasMyTournaments = user.isLoggedIn && data.find(x=>x.myRole)
  
        return (
            <div>
                <Helmet>
                    <title>Lasting Impact Tournaments | Speech and Debate</title>
                </Helmet>
                <br/>
                <div className="container">                                            
                    <SVGLinkCollection item={{
                        component: 'SVGLinkCollection',
                        items: [
                            {
                                name: 'Compete in a Tournament',
                                detail: 'Sign up to compete in one of our scheduled tournaments.',
                                svgName: 'svgSpeech',
                                link: '/pages/tournaments?mode=compete',
                                tags: 'admin'
                            },
                            {
                                name: 'Judge a Tournament',
                                detail: 'Sign up to judge a tournament.  No experience required!',
                                svgName: 'svgGavel',
                                link: '/pages/tournaments?mode=judge',
                                tags: 'admin'
                            },
                            {
                                name: 'Watch a Tournament',
                                detail: 'Come as a guest and watch an upcoming or ongoing tournament.',
                                svgName: 'svgBinoculars',
                                link: '/pages/tournaments?mode=watch',
                                tags: 'admin'
                            },
                            /*{
                                name: 'Run your own Tournament',
                                detail: 'Want to run your own tournament on Impact Tournament software?  Sign up here.',
                                svgName: 'svgDirector',
                                link: `/tournament/createTournament`,
                                tags: 'admin'
                            },*/
                            {
                                name: 'Tournament Calendar',
                                detail: 'Check out the schedule for upcoming and completed tournaments.',
                                svgName: 'svgCalendar',
                                link: '/pages/tournaments',
                                tags: 'admin'
                            },
                        ]
                    }} />  

                    <h3 style={{textAlign: "left", margin: "10px"}}>My Tournaments</h3>
                    {user.isLoggedIn ?
                        <>
                        {hasMyTournaments ?
                            <TournamentCollection cols="col-md-4" item={{
                                items: this.state.data && data.filter(x=>x.status === 'publish' && x.myRole).map((tp, index) => {
                                    return ({
                                        tp: tp,
                                        name: tp.title,
                                        imageUrl:  tp.imageUrl,
                                        link: `/pages/tournament/${tp._id}`
                                    })
                                })
                            }}/> 
                        : <p>We did not find any tournaments for your account.</p>
                        }     
                        </>
                    : 
                    <>
                    <p>Must logon to see your tournaments</p>
                    <div className="theme-card" style={{marginBottom: "27px"}}>
                        <AvForm id="loginForm" className="theme-form" onValidSubmit={this.onValidSubmit} onInvalidSubmit={this.onInvalidSubmit} >
                            <p>Please note: email address should be all lowercase.  Both email address and password are case sensitive.</p>
                            <div className="row">
                                <div className="col-lg-4">
                                    <div className="form-group">
                                        <label htmlFor="email">Email</label>
                                        <AvField required="" id="email" name="email" type="email" defaultValue={this.state.em} className="form-control" placeholder="Email" />
                                    </div>
                                </div>
                                <div className="col-lg-4">
                                    <div className="form-group">
                                        <label htmlFor="review">Password</label>
                                        <AvField required="" name="password" type="password" className="form-control" id="review"
                                            placeholder="Enter your password" />
                                    </div>
                                </div>
                                <div className="col-lg-4">
                                    <Button type="submit" className="btn btn-solid" style={{marginTop: "27px"}}>Login</Button>
                                    &nbsp;
                                    <Button className="btn btn-solid" onClick={this.forgot} style={{marginTop: "27px"}}>Forgot?</Button>
                                </div>
                            </div>
                        </AvForm>
                    </div>
                    </>
                    } 
                          
                         
                </div>
            </div>
        )
    }
}


export default Home;